import InvoicingEntitiesTab from './InvoicingEntitiesTab'
import './InvoicingEntitiesTab.sass'

export default InvoicingEntitiesTab
